import React, { Component, Suspense/*, lazy*/ } from 'react';
import ApplicationErrorBoundary from '../Global/ApplicationErrorBoundary';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch/*,
  Link*/ 
} from 'react-router-dom';
import { connect } from 'react-redux';
import Loader from '../Components/Loader';//'../hoc/Loader/Loader';
import ErrorComponent from '../Components/ErrorComponent';//'../hoc/Loader/Loader';
import Messages from '../hoc/Messages/Messages';
import { getToken} from '../Utils/UserFunctions';
import Headersection from '../Containers/Headersection';

import Reports from '../Pages/Reports/Reports';
import CreateReports from '../Pages/Reports/NewReports';
import CreateReportsV2 from '../Pages/Reports/NewReportsV2';
import SummaryReports from '../Pages/Reports/NewReports';
import GenerateReports from '../Pages/Reports/GenerateReports';

import Automations from '../Pages/Automations/Automations';
import AutomationsProcess from '../Pages/Automations/AutomationsProcess';
import Forecast from '../Pages/Forecast';
import Documents from '../Pages/Documents';
import Tags from '../Pages/Tags';

import Territories from '../Pages/Territories/Territories';
import TerritoryRules from '../Pages/Territories/TerritoryRules';
import AssignTerritories from '../Pages/Territories/AssignTerritories';

import TaxDetails from '../Pages/Orders/TaxDetails';
import ChargeDetails from '../Pages/Orders/ChargeDetails';

import Users from '../Pages/Users/Users';
import InactiveUsers from '../Pages/Users/InactiveUsers';

import PDFList from '../Pages/PdfAndExcel/PDFList';
import ExcelList from '../Pages/PdfAndExcel/ExcelList';
import AddPDF from '../Pages/PdfAndExcel/AddPDF';
import ExcelAdd from '../Pages/PdfAndExcel/ExcelAdd';

import DomainManagementContainer from '../Pages/DomainManagement/DomainManagement';
import DomainCertificateContainer from '../Pages/DomainManagement/DomainCertificate';

import ImportV2 from '../Pages/ImportExport/ImportV2';
import ExportV2 from '../Pages/ImportExport/ExportV2';

import CalculationList from '../Pages/Calculation/CalculationList';
import Calculation from '../Pages/Calculation/CalculationRates';

import Profiles from '../Pages/PermissionControls/Profiles';
import Roles from '../Pages/PermissionControls/Roles';
import DataSharing from '../Pages/PermissionControls/DataSharing';
import DataSharingRule from '../Pages/PermissionControls/DataSharingRule';
import ActionButton from '../Pages/PermissionControls/ActionButton';
import FieldAccess from '../Pages/PermissionControls/FieldAccess';

import EmailTemplate from '../Pages/EmailSettings/EmailTemplate';
import EmailSetup from '../Pages/EmailSettings/EmailSetup';
import SyncSetup from '../Pages/EmailSettings/SyncSetup';
import EmailToData from '../Pages/EmailSettings/EmailToData';
import EmailToDataCreate from '../Pages/EmailSettings/EmailToDataCreate';
import EmailTimeline from '../Pages/EmailSettings/EmailTimeline';
import EmailTemplateView from '../Pages/EmailSettings/EmailTemplateView';
import GlobalLoader from '../Components/Loader/GlobalLoader';
import { signUp } from '../store/actions';
import PagesInterface from '../Containers/PagesContainer/PagesInterface';
import history from '../history';

const Login = React.lazy(() => import('../Pages/Login'));
const SignUp = React.lazy(() => import('../Pages/SignUp'));
const ShippingModules = React.lazy(() => import('../Pages/ShippingModules'));
const APIModules = React.lazy(() => import('../Pages/APIModules'));
const WindowConversion = React.lazy(() => import('../Pages/WindowConversion'));
const ExchangeRate = React.lazy(() => import('../Pages/ExchangeRate'));
const ResetPassword = React.lazy(() => import('../Pages/ResetPassword'));
const ForgotPassword = React.lazy(() => import('../Pages/ForgotPassword'));
const Settings = React.lazy(() => import('../Pages/Settings'));
const FileImportContainer = React.lazy(() => import('../Pages/FileImport'));
const AddUser = React.lazy(() => import('../Pages/AddUser'));
const EditUser = React.lazy(() => import('../Pages/EditUser'));
const WorkFlow = React.lazy(() => import('../Pages/WorkFlow'));
const AddWorkFlow = React.lazy(() => import('../Pages/AddWorkFlow'));
const EditWorkFlow = React.lazy(() => import('../Pages/EditWorkFlow'));
const Windows = React.lazy(() => import('../Pages/Windows'));
const ImportProcess = React.lazy(() => import('../Pages/ImportProcess'));
const Organizations = React.lazy(() => import('../Pages/Organizations'));
const Dashboard = React.lazy(() => import('../Pages/Dashboard'));
const Logs = React.lazy(() => import('../Pages/Logs'));
const FlowChartModules = React.lazy(() => import('../Pages/FlowChartModules'));
const StepsFlowModule = React.lazy(() => import('../Pages/StepsFlowModule'));
const DomainProcessWizard = React.lazy(() => import('../Containers/DomainManagementContainer/DomainConfig/DomainProcessWizard'));
const Modules = React.lazy(() => import('../Pages/Modules'));
const RateSheet = React.lazy(() => import('../Pages/RateSheetPage'));
const RateSheetContainer = React.lazy(() => import('../Containers/RateSheetContainer'));
const ApprovalProcessModule = React.lazy(() => import('../Pages/ApprovalProcessModule'));
const StepProcessList = React.lazy(() => import('../Pages/StepProcessList'));
const AddOnModules = React.lazy(() => import('../Pages/AddOnModules'));
const MarketPlace = React.lazy(() => import('../Pages/MarketPlace'));
const HTMLEditor = React.lazy(() => import('../Pages/HTMLEditor'));
const Compiler = React.lazy(() => import('../Pages/Compiler'));
const CustomizeSourceCode = React.lazy(() => import('../Pages/CustomizeSourceCode'));
const Ftp = React.lazy(() => import('../Pages/Ftp'));
const EDI = React.lazy(() => import('../Pages/EDI'));
const LayoutModules = React.lazy(() => import('../Pages/LayoutModules'));

const RatingFlowModule = React.lazy(() => import('../Pages/RatingFlowModule'));
const IntelligenceEnhancerModule = React.lazy(() => import('../Pages/IntelligenceEnhancerModule'));

const PagesModule = React.lazy(() => import('../Pages/PagesModules/PagesModule'));
const PagesSettingsModule = React.lazy(() => import('../Pages/PagesModules/PagesSettingsModule'));


// const Reports = React.lazy(() => import('../Pages/Reports/Reports'));
// const CreateReports = React.lazy(() => import('../Pages/Reports/NewReports'));
// const SummaryReports = React.lazy(() => import('../Pages/Reports/NewReports'));
// const GenerateReports = React.lazy(() => import('../Pages/Reports/GenerateReports'));
// const Automations = React.lazy(() => import('../Pages/Automations/Automations'));
// const AutomationsProcess = React.lazy(() => import('../Pages/Automations/AutomationsProcess'));
// const Forecast = React.lazy(() => import('../Pages/Forecast'));
// const Documents = React.lazy(() => import('../Pages/Documents'));
// const Tags = React.lazy(() => import('../Pages/Tags'));

// const Territories = React.lazy(() => import('../Pages/Territories/Territories'));
// const TerritoryRules = React.lazy(() => import('../Pages/Territories/TerritoryRules'));
// const AssignTerritories = React.lazy(() => import('../Pages/Territories/AssignTerritories'));

// const TaxDetails = React.lazy(() => import('../Pages/Orders/TaxDetails'));
// const ChargeDetails = React.lazy(() => import('../Pages/Orders/ChargeDetails'));

// const Users = React.lazy(() => import('../Pages/Users/Users'));
// const InactiveUsers = React.lazy(() => import('../Pages/Users/InactiveUsers'));

// const PDFList = React.lazy(() => import('../Pages/PdfAndExcel/PDFList'));
// const ExcelList = React.lazy(() => import('../Pages/PdfAndExcel/ExcelList'));
// const AddPDF = React.lazy(() => import('../Pages/PdfAndExcel/AddPDF'));
// const ExcelAdd = React.lazy(() => import('../Pages/PdfAndExcel/ExcelAdd'));

// const DomainManagementContainer = React.lazy(() => import('../Pages/DomainManagement/DomainManagement'));
// const DomainCertificateContainer = React.lazy(() => import('../Pages/DomainManagement/DomainCertificate'));

// const ImportV2 = React.lazy(() => import('../Pages/ImportExport/ImportV2'));
// const ExportV2 = React.lazy(() => import('../Pages/ImportExport/ExportV2'));

// const CalculationList = React.lazy(() => import('../Pages/Calculation/CalculationList'));
// const Calculation = React.lazy(() => import('../Pages/Calculation/CalculationRates'));

// const Profiles = React.lazy(() => import('../Pages/PermissionControls/Profiles'));
// const Roles = React.lazy(() => import('../Pages/PermissionControls/Roles'));
// const DataSharing = React.lazy(() => import('../Pages/PermissionControls/DataSharing'));
// const DataSharingRule = React.lazy(() => import('../Pages/PermissionControls/DataSharingRule'));
// const ActionButton = React.lazy(() => import('../Pages/PermissionControls/ActionButton'));
// const FieldAccess = React.lazy(() => import('../Pages/PermissionControls/FieldAccess'));

// const EmailTemplate = React.lazy(() => import('../Pages/EmailSettings/EmailTemplate'));
// const EmailSetup = React.lazy(() => import('../Pages/EmailSettings/EmailSetup'));
// const SyncSetup = React.lazy(() => import('../Pages/EmailSettings/SyncSetup'));
// const EmailToData = React.lazy(() => import('../Pages/EmailSettings/EmailToData'));
// const EmailToDataCreate = React.lazy(() => import('../Pages/EmailSettings/EmailToDataCreate'));
// const EmailTimeline = React.lazy(() => import('../Pages/EmailSettings/EmailTimeline'));
// const EmailTemplateView = React.lazy(() => import('../Pages/EmailSettings/EmailTemplateView'));

class Routes extends Component {
	constructor(props) {
		super(props);
		this.state = {
		//   reminderDetails:{
		// 	  key:null,
		// 	  display:false,
		//   }
		}
  }
  componentWillUnmount() {
	window.removeEventListener('storage', this.handleStorageChange);
	window.removeEventListener("message", this.handleMessage);

  }
   handleMessage = (event) => {
    if (event.data && event.data.type === "NAVIGATE") {
		console.log('history',history);
      history.push(event.data.path);
    }
  };

	componentDidMount = ()=> {
		const token = getToken();
		 window.addEventListener("message", this.handleMessage);
		//   window.sharedHistoryPush = (path) => {
		// 	console.log('ssss');
		// 		history.push(path);
		// 		};
		this.handleStorageChange = (event) => {
            if (event.key === 'access_token' && !event.newValue) {
                // If access_token is cleared, refresh the tab
                window.location.reload();
            }
        };
		window.addEventListener('storage', this.handleStorageChange);
        
		if(token != null) {
				this.props.onAuthenticated();
				// console.log(currentTime);
				const moduleId = localStorage.getItem('moduleId');
				// console.log(moduleId);
				if(moduleId) {
					this.props.leftMenuGenerateHandler(moduleId);	
				}
			}
	}

		/*componentDidCatch = (error, info) => {
			console.log(error, info);
			// Display fallback UI    
			// this.setState({ hasError: true });    
			// You can also log the error to an error reporting service    
			// logErrorToMyService(error, info);  
		}*/
		
    render() {
    	const pages = [
	      {
	        pageLink: '/login',
	        view: Login,
	        displayName: 'Login'
	      },
	      {
	        pageLink: '/signup',
	        view: signUp,
	        displayName: 'SignUp'
	      },
	      {
	        pageLink: '/forgot-password',
	        view: ForgotPassword,
	        displayName: 'ForgotPassword'
	      },
	      {
	        pageLink: '/reset-password',
	        view: ResetPassword,
	        displayName: 'ResetPassword'
	      },
		  {
	        pageLink: '/flowchart/:page?', 
	        view: FlowChartModules,
	        displayName: 'FlowChart' 
	      }, 
		  {
	        pageLink: '/ratings/*', 
	        view: RatingFlowModule,
	        displayName: 'Ratings'
	      }, 
		  {
			pageLink:'/steps/:page?/:formId?/:stepName?',
			view:StepsFlowModule,
			displayName:'Steps'
		  },
		  { 
			pageLink: '/conversion/:windowName?/:windowId?/:page?/:formId?',
	        view: WindowConversion,
			displayName: 'WindowConversion',
		  },
		  {
			pageLink:'/settings/pages/*',
			view:PagesSettingsModule,
			displayName:'PagesModule',
		  },
		   {
			pageLink:'/pages/:configKey',
			view:PagesModule,
			displayName:'PagesModule',
		  },
		//   { 
		// 	pageLink: '/shipments/:windowName/:windowId/:page?/:layoutId?/:formId?/:rand?',
	    //     view: ShippingModules,
		// 	displayName: 'ShippingModules',
		//   },
		{ 
			pageLink: '/settings/exchange-rate',
	        view: ExchangeRate,
			displayName: 'ExchangeRate',
		  },
		  { 
			pageLink: '/shipping/:windowName/:windowId/:page?/:layoutId?/:carrierId?/:formId?/:action?/:rand?',
	        view: ShippingModules,
			displayName: 'ShippingModules',
		  },
		  { 
			pageLink: '/sheet/:page/:name?/:sheetId?',
	        view: RateSheet,
			displayName: 'RateSheet',
		  },
		  { 
			pageLink: '/rate-sheet/:page?/:name?/:sheetId?',
	        view: RateSheetContainer,
			displayName: 'RateSheetContainer',
		  },
	      { 
	        pageLink: '/layouts/:windowName/:windowId/:page?/:layoutId?/:formId?/:rand?/:rand1?',
	        view: LayoutModules,
			displayName: 'LayoutModules',
		  },
		  { 
	        pageLink: '/settings/:windowName/:windowId/:page?/:layoutId?/:formId?/:rand?',
	        view: LayoutModules,
			displayName: 'LayoutModules',
		  },
		  {
			pageLink: '/permission-controls',
			view: Profiles,
			displayName: 'profiles'
		  },
		  {
			pageLink: '/permission-controls/profiles',
			view: Profiles,
			displayName: 'profiles'
		  },
		  {
			pageLink: '/permission-controls/profiles/:profileId',
			view: Profiles,
			displayName: 'profiles'
		  },
		  {
			pageLink: '/permission-controls/roles',
			view: Roles,
			displayName: 'Roles'
		  },
		  {
			pageLink: '/permission-controls/field-access',
			view: FieldAccess,
			displayName: 'FieldAccess'
	      },
	      {
			pageLink: '/permission-controls/data-sharing',
			view: DataSharing,
			displayName: 'DataSharing'
		  },
		  {
			pageLink: '/permission-controls/data-sharingrule',
			view: DataSharingRule,
			displayName: 'DataSharing Rule'
		  },
		  {
			pageLink: '/permission-controls/action-button',
			view: ActionButton,
			displayName: 'Action Button'
		  },
	      {
	        pageLink: '/settings',
	        view: Settings,
	        displayName: 'Settings'
	      },
		  {
	        pageLink: '/api/:page?/:formId?/:action?',
	        view: APIModules,
	        displayName: 'API'
	      },
	      {
	        pageLink: '/import/:windowName/:windowId',
	        view: FileImportContainer,
	        displayName: 'Module Import'
		  },
		  {
	        pageLink: '/adduser',
	        view: AddUser,
	        displayName: 'AddUser'
		  },
	      {
	        pageLink: '/users',
	        view: Users,
	        displayName: 'Users'
	      },
	      {
	        pageLink: '/inactive-users',
	        view: InactiveUsers,
	        displayName: 'Users'
	      },
	      {
	      	pageLink: '/edit-user/:id',
	        view: EditUser,
	        displayName: 'Users'
	      },
	      {
	      	pageLink: '/workflow',
	        view: WorkFlow,
	        displayName: 'WorkFlow'
	      },
	      {
	      	pageLink: '/add-workflow',
	        view: AddWorkFlow,
	        displayName: 'AddWorkFlow'
	      },
	      {
	      	pageLink: '/edit-workflow/:id',
	        view: EditWorkFlow,
	        displayName: 'EditWorkFlow'
		  },
		  {
			pageLink: '/settings/windows',
			view: Windows,
			displayName: 'Windows'
		  },
		  {
			pageLink: '/settings/modules',
			view: Modules,
			displayName: 'Modules'
		  },
		  {
			pageLink: '/import-process',
			view: ImportProcess,
			displayName: 'ImportProcess'
		  },
		  {
			pageLink: '/import-export/import',
		  	view: ImportV2,
		  	displayName: 'Import'
		  },
		  {
		  	pageLink: '/import-export/export',
		  	view: ExportV2,
			displayName: 'Export'
		  },
		  {
		  	pageLink: '/email-settings/email-template',
		  	view: EmailTemplate,
			displayName: 'EmailTemplate'
		   },
		   {
			pageLink: '/email-settings/email',
			view: EmailSetup,
			displayName: 'EmailSetup'
		   },
		   {
			pageLink: '/email-settings/email/:emailName/:windowId?/:formId?/:messageGroupId?',
			view: EmailSetup,
			displayName: 'EmailSetup'
		   },
		   {
			pageLink: '/email-settings/sync-setup',
			view: SyncSetup,
			displayName: 'SyncSetup'
		   },
		   {
			pageLink: '/email-settings/email-to-data',
			view: EmailToData,
			displayName: 'EamilToData'
		   },
		   {
			pageLink: '/email-settings/email-to-data/create-new',
			view: EmailToDataCreate,
			displayName: 'EamilToDataCreate'
		   },
		   {
			pageLink: '/email-settings/email-to-data/emaildata/:emailDataId?',
			view: EmailToDataCreate,
			displayName: 'EamilToDataCreate'
		   },
		   {
			pageLink: '/email-settings/email-timeline',
			view: EmailTimeline,
			displayName: 'EmailTimeline'
		   },		   
		   {
			pageLink: '/organizations/:page',
			view: Organizations,
			displayName: 'Organizations'
		   },
		   {
			pageLink: '/company/:page/:companyId?',
			view: Organizations,
			displayName: 'Company Info'
		   },
		   {
			pageLink: '/user/:page/:userId?',
			view: Organizations,
			displayName: 'Company Info'
		   },
		   {
			pageLink: '/reports/:folderId/list',
			view: Reports,
			displayName: 'Reports'
		   },
		   {
			pageLink: '/reports',
			view: Reports,
			displayName: 'Reports'
		   },
		   {
			pageLink: '/reports/create-reports/:reportType?',
			view: CreateReports,
			displayName: 'Create Reports'
		   },
		   {
			pageLink: '/reports/create-reports-v2/:reportId?',
			view: CreateReportsV2,
			displayName: 'Create Reports V2'
		   },
		   {
			pageLink: '/reports/summary-reports/:reportId?/:reportData?',
			view: SummaryReports,
			displayName: 'Summary Reports'
		   },
		   {
			pageLink: '/reports/generate-reports/:reportId?/:reportData?',
			view: GenerateReports,
			displayName: 'Summary Reports'
		   },
		   {
			pageLink: '/territories',
			view: Territories,
			displayName: 'Territories'
		   },
		   {
			pageLink: '/territory-rules',
			view: TerritoryRules,
			displayName: 'TerritoryRules'
		   },
		   {
			pageLink: '/territory-assign',
			view: AssignTerritories,
			displayName: 'AssignTerritories'
		   },
		   {
			pageLink: '/forecast',
			view: Forecast,
			displayName: 'Forecast'
		   },
		   {
			pageLink: '/tax-list',
			view: TaxDetails,
			displayName: 'TaxDetails'
		   },
		   {
			pageLink: '/charge-list',
			view: ChargeDetails,
			displayName: 'ChargeDetails'
		   },	
		   {
			pageLink: '/documents',
			view: Documents,
			displayName: 'Documents'
		   },
		   {
			pageLink: '/tags/tags-list',
			view: Tags,
			displayName: 'Tags'
		   },
		   {
			pageLink: '/dashboard',
			view: Dashboard,
			displayName: 'Dashboard'
		   },
		   {
			pageLink: '/logs/logs-list',
			view: Logs,
			displayName: 'Logs'
		   },
		   {
			pageLink: '/automation/automation-list',
			view: Automations,
			displayName: 'Automations'
		   },
		   {
			pageLink: '/automation/:automationId/process-list',
			view: AutomationsProcess,
			displayName: 'Automations Process'
		   },
		   {
			pageLink: '/calculation/calculation-list',
			view: CalculationList,
			displayName: 'Calculation'
		   },
		   {
				pageLink: '/calculation/:calculationId',
				view: Calculation,
				displayName: 'CalculationList'
		   },{
				pageLink:'/domain-management',
				view: DomainManagementContainer,
				displayName: 'Domain Management'
		   },{
				pageLink:'/domain-management/domain-config',
				view: DomainManagementContainer,
				displayName: 'Domain Management'
		   },{
				pageLink:'/domain-management/certificate-config',
				view: DomainCertificateContainer,
				displayName: 'Domain Management'
			},{
				pageLink:'/domain-management/domain-config/edit/:domainId',
				view: DomainProcessWizard,
				displayName: 'Domain Management'
			},{
				pageLink:"/domain-management/domain-config/create",
				view: DomainProcessWizard,
				displayName:"Domain Management"
		   },{
				pageLink:'/pdf/pdf-list',
				view: PDFList,
				displayName: 'PDF List'
		   },{
				pageLink:'/pdf-template/:pdfTemplateId',
				view: AddPDF,
				displayName: 'PDF Template Create'
		   },{
				pageLink:'/excel/excel-list',
				view: ExcelList,
				displayName: 'Excel List'
		   },{
				pageLink:'/excel-template/:excelTemplateId',
				view: ExcelAdd,
				displayName: 'Excel List'
		   },
		   {
				pageLink:'/email-template/:emailTemplateId',
				view: EmailTemplateView,
				displayName: 'Email Template'
		   },
		   {
		   	pageLink:'/approval-process/:approvalProcessId?',
		   	view: ApprovalProcessModule,
		   	displayName: 'Approval Process'
		   },
		   {
				pageLink: '/step-process-list',
				view: StepProcessList,
				displayName: 'StepProcess'
			  },
			  { 
	        pageLink: '/add-on/:page?/:id?/:versionId?', //'/add-on/:page?/:layoutId?/:formId?/:rand?/:rand1?'
	        view: AddOnModules,
					displayName: 'AddOnModules',
		  	},
		  	{ 
	        pageLink: '/html-editor',
	        view: HTMLEditor,
					displayName: 'HTMLEditor',
		  	},
			  { 
	        pageLink: '/market-place/:page?', //'/add-on/:page?/:layoutId?/:formId?/:rand?/:rand1?'
	        view: MarketPlace,
					displayName: 'MarketPlace',
		  	},
			{
				pageLink: '/intelligence-enhancer/provider-configs',
				view: IntelligenceEnhancerModule,
				displayName: 'Intelligence Enhancer'
			},
			{
				pageLink: '/intelligence-enhancer/prompt-templates',
				view: IntelligenceEnhancerModule,
				displayName: 'Intelligence Enhancer Prompt Templates'
			},
			{
				pageLink: '/compiler',
				view: Compiler,
				displayName: 'Compiler'
			},
			{
				pageLink: '/compiler/:page?/:classId?/:name?',
				view: CustomizeSourceCode,
				displayName: 'Compiler'
			},
			{
				pageLink: '/ftp-list',
				view: Ftp,
				displayName: 'FTP'
			},
			{
				pageLink: '/ftp/:page?/:ftpId?/:name?',
				view: Ftp,
				displayName: 'FTP'
			},
			{
				pageLink: '/edi/:page?/:ediId?',
				view: EDI,
				displayName: 'EDI'
			},{
				pageLink:"/tracking/:page/:trackingNumber",
				view:Login,
				displayName:"Tracking"
			},{
				pageLink:"/tracking/:trackingNumber?",
				view:Login,
				displayName:"Tracking"
			}
	    ];

	    const token = getToken();
		let allowHeaderSection = true;
	    // console.log('token',localStorage);
	    let isAuthenticated = false;
	    if(token != null) {
	    	isAuthenticated = true;
			if(window.location.pathname.startsWith("/tracking")){
				allowHeaderSection = false;
			}
			if(window.location.pathname.startsWith("/pages/window")){
				allowHeaderSection = false;
			}
	    }
		
    	return(
			
    		<div className="wrapper">
    			<Messages />
				<Loader />
				{
					this.props.isErrorModalOpen === true?
					<ErrorComponent />
					:
					null
				}
				
				<Router history={history}> 
			    <ApplicationErrorBoundary>
			    {
			    !isAuthenticated ?

			    	<Suspense fallback={
						<GlobalLoader />
					}>
			    	<Switch>
				    	<Route exact path="/login" component={Login} />
				    	<Route exact path="/signup" component={SignUp} />
				    	<Route exact path="/forgot-password" component={ForgotPassword} />
				    	<Route exact path="/reset-password" component={ResetPassword} />
						<Route exact path="/tracking/:page/:trackingNumber" component={Login} />
						<Route exact path="/tracking/:trackingNumber?" component={Login} />
				    	<Redirect to="/login"/>
				    </Switch>
				    </Suspense> 

				    :

			        <>
						{
							(allowHeaderSection)?
							<Headersection 
								selectedModule={this.props.selectedWindowData}
								leftMenuGenerateHandler={this.props.leftMenuGenerateHandler}
								windowsMenusList={this.props.windowsMenusList}
							/>:<></>						
						}
						<Suspense fallback={
							<GlobalLoader />
											}>
						  <Route
				            render={({location}) => (
				                <Switch location={location}>
				                	<Redirect from='/login' to='/settings' />
                         
									 <Redirect from='/signup' to='/settings' /> 
									<Redirect from='/forgot-password' to='/settings' />
									<Redirect from='/reset-password' to='/settings' />
				                  {pages.map((page, index) => {
									 	return (
											
											<Route
											  exact
											  path={page.pageLink}
											  render={({match}) => (
												<page.view key={match.params.stateCode || index}/>
											  )}
											  key={index}
											/>
										  );
				                  })}
				                  <Redirect to="/settings" />
				                </Switch>
				            )}
				          />
			        </Suspense> 
					<PagesInterface  pageType="POPUP" />
					</>
			    }
			    </ApplicationErrorBoundary>	
			  	</Router>
			</div>
		
			
		)
	};
}

const mapStateToProps = (state, ownProps) => {
  return {
    authenticated: state.reducer.authenticated,
	// loading : state.commonReducer.loading,
	selectedWindowData:state.reducer.selectedWindowData,
	windowsMenusList:state.reducer.windowsMenusList,
	isErrorModalOpen:state.ErrorSetupReducer.isErrorModalOpen,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onIncrmentCounter : () => dispatch({type : 'INC_COUNTER'}),
	onAuthenticated : () => dispatch({type : 'AUTHENTICATED', value: true}),
	leftMenuGenerateHandler:(moduleId) => dispatch({type : 'MODULE_CHANGE',moduleId:moduleId}),
	menusListUpdates:() => dispatch({type : 'WINDOWS_MENUS_UPDATE'})
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Routes);